import moment from 'moment';
import React from 'react';
import { DATE_FORMAT } from '../../../../../general/model';

export const DateCell: React.FC<{ cellData: any }> = (props) => {
  const value = props.cellData ? moment(props.cellData).format(DATE_FORMAT) : '';
  return <>{value}</>;
};
